import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableTdCartExpandedFn = /* @__PURE__ */ createRecipe('table-td-cart-expanded', {}, [])

const tableTdCartExpandedVariantMap = {}

const tableTdCartExpandedVariantKeys = Object.keys(tableTdCartExpandedVariantMap)

export const tableTdCartExpanded = /* @__PURE__ */ Object.assign(memo(tableTdCartExpandedFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableTdCartExpanded',
  __getCompoundVariantCss__: tableTdCartExpandedFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableTdCartExpandedVariantKeys,
  variantMap: tableTdCartExpandedVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableTdCartExpandedVariantKeys)
  },
  getVariantProps: tableTdCartExpandedFn.getVariantProps,
})